import React from 'react';
import Highlighter from './Highlighter';

function CheckList({
  items,
  selectedIds = [],
  titleName = 'name',
  onSelectCheckbox,
  errorMsg,
  highlightSearch,
  classNames = '',
}) {
  if (!items) return [];

  let checkboxContainer = items.map((item, index) => {
    let checked = selectedIds.indexOf(item.id);
    const uniqueKey = '_' + index + item.id;
    return (
      <li
        key={uniqueKey}
        value={item.id}
        onClick={() => onSelectCheckbox(item)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSelectCheckbox(item);
          }
        }}
        className={'pointer line-height-25  ' + (checked !== -1 ? 'selectedCheckbox ' : 'unSelectCheckbox')}>
        <span
          tabIndex={0}
          role={'checkbox'}
          aria-checked={checked !== -1}
          aria-labelledby={`checkboxItem${uniqueKey}`}
          className="checkbox-list">
          <i className={'checkBox far ' + (checked !== -1 ? 'fa-check-square' : 'fa-square')}></i>
        </span>
        <span id={`checkboxItem${uniqueKey}`} className="checkBox-title">
          <Highlighter textToHighlight={item[titleName]} searchWords={highlightSearch} />
        </span>
      </li>
    );
  });

  return (
    <div className={classNames + ' check-list-container'}>
      <ul className="check-list">{checkboxContainer}</ul>
      {errorMsg ? (
        <div role="alert" className="error-msg mTop-5 mBottom-15">
          <span className="input-error"> {errorMsg}</span>
        </div>
      ) : null}
    </div>
  );
}

export default CheckList;
